import { mapGetters } from 'vuex';
import accountVerifyMixin from '@/mixins/accountVerify';
import socialLevelMixin from '@/mixins/socialLevel';
import unreadNotificationMixin from '@/mixins/unreadNotification';

export default {
  mixins: [
    accountVerifyMixin,
    socialLevelMixin,
    unreadNotificationMixin,
  ],
  props: {
    showIcons: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isShutdownModeOn']),
    ...mapGetters('user', ['isLoggedIn']),
    classModifiers() {
      return {
        'main-nav-old': true,
        'main-nav-old--shutdown': this.isShutdownModeOn,
      };
    },
    filteredUrls() {
      return this.urls.filter(i => !i.disabled);
    },
    urls() {
      if (this.isShutdownModeOn && !this.isLoggedIn) {
        return [
          // {
          //   title: 'Insights',
          //   name: 'insight',
          //   href: '/insight',
          // },
          {
            title: 'Support',
            name: 'help',
            href: '/support',
          },
        ];
      }

      if (this.isShutdownModeOn && this.isLoggedIn && this.isLayoutMobile) {
        return [
          {
            title: 'Account',
            name: 'account',
            href: this.accountLink,
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
          },
          {
            title: 'Support',
            name: 'help',
            href: '/support',
          },
        ];
      }

      if (this.isShutdownModeOn && this.isLoggedIn && !this.isLayoutMobile) {
        return [
          {
            title: 'Account',
            name: 'account',
            href: this.accountLink,
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
          },
          {
            title: 'Support',
            name: 'help',
            href: '/support',
          },
        ];
      }

      if (this.isLoggedIn && this.isLayoutMobile) {
        return [
          {
            title: 'Markets',
            name: 'markets',
            href: '/markets',
          },
          {
            title: 'Trends',
            name: 'trends',
            href: '/trends',
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
          },
          {
            title: 'Leaderboards',
            name: 'leaderboards',
            href: '/leaderboards',
            disabled: !process.env.LEADERBOARDS_ENABLED,
          },
          {
            title: 'Account',
            name: 'account',
            href: this.accountLink,
          },
          {
            title: 'Support',
            name: 'help',
            href: '/support',
            disabled: process.env.LEADERBOARDS_ENABLED,
          },
        ];
      }

      if (this.isLoggedIn && !this.isLayoutMobile) {
        return [
          {
            title: 'Markets',
            name: 'markets',
            href: '/markets',
          },
          {
            title: 'Trends',
            name: 'trends',
            href: '/trends',
          },
          {
            title: 'Leaderboards',
            name: 'leaderboards',
            href: '/leaderboards',
            disabled: !process.env.LEADERBOARDS_ENABLED,
          },
          {
            title: 'Account',
            name: 'account',
            href: this.accountLink,
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
          },
        ];
      }

      return [
        {
          title: 'Markets',
          name: 'markets',
          href: '/markets',
        },
        // {
        //   title: 'Insights',
        //   name: 'insight',
        //   href: '/insight',
        // },
        {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          disabled: !process.env.LEADERBOARDS_ENABLED,
        },
        {
          title: 'Support',
          name: 'help',
          href: '/support',
        },
      ];
    },
  },
  methods: {
    classModifier(name) {
      const routes = [
        'market-details',
      ];
      const dontHighlight = routes.includes(this.$route.name);
      return {
        [`main-nav-old__link-with-icon main-nav-old__link-with-icon--${name}`]: this.showIcons,
        'main-nav-old__link--no-highlight': dontHighlight,
        'main-nav-old__link': true,
      };
    },
    showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile &&
        item.name === 'dashboard' &&
        this.isLoggedIn;
    },
    showRegularItem(item) {
      return this.isLayoutMobile ? item.name !== 'dashboard' : true;
    },
    onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-main-nav/app-main-nav.js